export default {
  MAX_FILE_SIZE: 50000000,
  MAX_FILE_UPLOAD_LIMIT: 3,
  MAX_TEXT_COUNT: 160,
};
